import axios from "./instance";

// Fetch all discussions for a project
export const getDiscussionsByProject = async (projectId) => {
  try {
    const res = await axios.get(`http://localhost:8000/api/project-discussions/project/${projectId}`);
    return res.data;
  } catch (error) {
    console.error("Error fetching discussions:", error);
    throw error;
  }
};

// Create a new discussion
export const createProjectDiscussion = async (discussionData) => {
  try {
    const res = await axios.post(`http://localhost:8000/api/project-discussions`, discussionData);
    return res.data;
  } catch (error) {
    console.error(`Error creating discussion for project ${discussionData.projectId}:`, error);
    throw error;
  }
};

export const updateProjectDiscussion = async (discussionID, discussionData) => {
  try {
    const res = await axios.patch(`http://localhost:8000/api/project-discussions/${discussionID}`, discussionData);
    return res.data;
  } catch (error) {
    console.error(`Error updating discussion with ID ${discussionID}:`, error);
    throw error;
  }
};
// Delete a discussion
export const deleteDiscussion = async (discussionId) => {
  try {
    const res = await axios.delete(`http://localhost:8000/api/project-discussions/${discussionId}`);
    return res.data;
  } catch (error) {
    console.error(`Error deleting discussion with ID ${discussionId}:`, error);
    throw error;
  }
};
